<template>
    <b-row style="position:fixed;top:0;bottom:0;right:0;left:0;overflow:auto;" md="12">
        <b-col v-if="!hideCarousel" md="5" class="carousel-side d-flex justify-content-center align-items-center hidden-md-down" style="background-color:#4129A8;">
                <carousel></carousel>
        </b-col>
        <b-col :md="hideCarousel ? 12 : 7" style="background-color:#fff;" class="form-side d-flex">
            <b-card 
            :img-src="showLogo ? logoImg : ''"
            img-alt="Image"
            img-top
            style="width:25%;min-width:30rem;margin:auto;border:none;color:#022B49;"
            >
                <b-row style="position: relative">
                    <b-col>
                        <b-alert :show="showInvalidUserAlert"
                                dismissible
                                variant="danger"
                                class="alert-danger-cl"
                                style="width: 100%; position: relative; right: 0; left: 0; margin: auto; margin-top: 10% z-index:3;">
                                <span style="font-size:1em;">{{ $t('alert') }}</span>
                        </b-alert>
                    </b-col>
                </b-row>
                <b-row class="m-3" style="font-weight: bold; margin-bottom:3px; font-size: 1.75em;">
                    <b-col>
                        <span style="text-align: center;">{{$t('forgotPassword')}}</span>
                    </b-col>
                </b-row>
                <b-row class="m-3" style="font-weight: bold; margin-bottom:10px; font-size: 0.75em;color:#8E8E8E;">
                    <b-col>
                        {{ $t('explanation')}}
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="mb-3 mt-3">
                        <b-input-group>
                            <b-input-group-prepend is-text>
                                <img src="../assets/icon/mail_icon.svg"/>
                            </b-input-group-prepend>
                            <b-form-input v-model="email" :placeholder="$t('emailPlaceholder')" type="text" class="input-field" :class="['input-field', {'is-invalid': emailError}]" required/>
                        </b-input-group>
                        <span v-show="emailError" class="validation-error">{{$t('emptyEmail')}}</span>
                    </b-col>
                </b-row>
                <b-row> 
                    <b-col class="mt-3">
                        <b-button @click="forgotPassword(email)" class="w-50 light-green" >{{ $t('sendInstructions') }}</b-button>
                    </b-col>
                </b-row>
                <!--
                <b-row> 
                    <b-col class="mt-3">
                        <span>{{$t('dontHaveAccount')}} <router-link :to="{name: 'sign-up'}" class="link">{{$t('signUp')}}</router-link></span>
                    </b-col>
                </b-row>
                -->
                <b-row> 
                    <b-col class="mt-3">
                        <span><router-link :to="{name: 'login'}" class="link">{{$t('backToLogin')}}</router-link></span>
                    </b-col>
                </b-row>
            </b-card>
        </b-col>

    </b-row>

</template>

<script>
import Carousel from '../components/Carousel.vue';
export default {
    components: { Carousel },
    name: 'ForgotPassword',
    data() {
        return {
            email: null,
            err: null,
            emailError: false,
            title: 'Carbon Intelligence',
            logoImg: '../../static/background.jpg',
            showLogo: false,
            showInvalidUserAlert: false,
            hideCarousel: false
        };
    },
    methods: {
        isValid(){
            this.emailError = !this.email;
            return !this.emailError;
        },
        forgotPassword(email) {
            if(this.isValid()){
                this.$Progress.start();
                return this.axios
                    .post('/forgotPassword', {email})
                    .then(() => {
                        this.$router.push({path: '/login', query:{passwordResetInfo:true}});
                        this.$Progress.finish();
                        return true;
                    })
                    .catch(err => {
                        this.showInvalidUserAlert = true;
                        this.err = err;
                        this.$Progress.finish();
                    });
            }
        },
        onResize(){
            this.windowHeight = window.innerHeight;
            this.windowWidth = window.innerWidth;
            this.hideCarousel = this.windowWidth < 1080;
        }
    },
    created(){
        this.onResize();
    },
    mounted() {
        window.addEventListener('resize', this.onResize);
        if (window.location.href.match('garanti')) {
            this.logoImg = '../../static/garanti.png';
            this.title = 'titleGaranti';
            this.showLogo = true;
            this.hideCarousel = true;
        }
    },
    beforeDestroy(){
        window.removeEventListener('resize', this.onResize);
    }
    
};
</script>

<style lang="scss" scoped>
.carousel-side, .form-side {
    height: 100vh;
    width: 100%;
}
.input-field {
    background-color: #EFEDF5;
    color: #022B49;
    font-size: 1em;
}
.input-field::placeholder {
    color : #A0A0A0;
}
.input-field:focus {
    outline: none !important;
    border:1px solid #8276c3;
    box-shadow: none;
}

.validation-error {
    color: #F14079;
    float: left;
    font-size: .7em;
}

a {
    color: #D118A8;
    text-decoration: underline;
    font-weight: bold;
}

.alert-info-cl{
    color: #407994; 
    background-color:rbga(241,64,121,0.2) !important;
}
.alert-danger-cl{
    color: #F14079; 
    background-color:rbga(241,64,121,0.2) !important;
}

.input-group-prepend .input-group-text {
  background-color: #EFEDF5;
}
.input-group-append .input-group-text {
  background-color: #EFEDF5;
}

a {
    color: #D118A8;
    text-decoration: underline;
    font-weight: bold;
}

.light-green {
    background-color: #49DC9B;
    font-weight: bold;
    border: none;
}
.captcha-input {
    position: relative;
    width: 180px;
    padding: 5px;
    font-size: 16px;
    margin: auto;
}


</style>

<i18n>
    {
        "tr": {
            "title":"Reengen Sürdürülebilirlik Platformu",
            "titleGaranti":"Çevre Yönetim Sistemi Yazılımı (ÇYS)",
            "alert": "Email adresi bulunamadı",
            "inputPlaceholderUsername" : "E-posta Adresi",
            "sendInstructions" : "Talimatları Gönder",
            "forgotPassword": "Parolanızı mı Unuttunuz?",
            "emptyEmail": "Lütfen e-posta adresinizi girin",
            "emailPlaceholder": "E-posta",
            "explanation": "Kayıt olurken kullandığınız e-posta adresini girin. Şifre sıfırlamak için gerekli talimatları mail ile ileteceğiz.",
            "dontHaveAccount": "Hesabınız yok mu?",
            "signUp": "Kayıt ol",
            "backToLogin": "Giriş ekranına dön"

        },
        "en": {
            "title":"Reengen Sustainability Platform",
            "titleGaranti":"Environmental Management System Software (EMS)",
            "alert": "Email address not found",
            "inputPlaceholderUsername" : "Email Address",
            "sendInstructions" : "Send Instructions",
            "forgotPassword": "Forgot Password?",
            "emptyEmail": "Please enter your email",
            "emailPlaceholder": "Email",
            "explanation": "Enter the email address you used when you joined and we’ll send you instructions to reset your password.",
            "dontHaveAccount": "Don't have an Account?",
            "signUp": "Sign up",
            "backToLogin": "Back To Login"
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/views/ForgotPassword.vue